// React Imports
import React, { Component } from "react";

// Package Imports
import { observer } from "mobx-react";
import { Image, Modal, Row, Col, Container } from "react-bootstrap";
import moment from "moment";

// Project Imports
import AuthStore from "../../../modules/login/store/AuthStore";
import { NextButton, Button as UiButton } from "../../../components";
import ChooseNeedsStore from "../../../modules/choose-needs/store/ChooseNeedsStore";
import OptimizationStore from "../../../modules/optimization/store/OptimizationStore";
import OptimizationStoreOld from "../../../modules/optimization-old/store/OptimizationStore";
import { ShareIconImg } from "constants/Images";
import FormContext from "context/FormContext";
import * as APITypes from "constants/API"
import axios from "utils/axios";
import chooseNeedUtils from "modules/choose-needs/components/form/choose-needs/utils";
import { toJS } from "mobx";

import SolutionStore from '../../../modules/solution/store/SolutionStore'
import QuotationPreviewUtils from "modules/quotation-preview/utils";

// CSS Imports
import "./breadcrumb.css";
import StorageKeys from "constants/StorageKeys";
import FamilyDetailsStore from "modules/family-details-form/store/FamilyDetailsStore";
import checkIsValueEmpty from "utils/checkIsValueEmpty";
import { Link } from "react-router-dom";
import QuotationPreviewStore from "modules/quotation-preview/QuotationPreviewStore";
import PreNeedSelectionModal from "modules/pre-need-selection-modal/components/PreNeedSelectionModal";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { BANCA_JOURNEY, COOKIE_PARA_NAME_FOR_JOURNEY_ID, SAMS_JOURNEY } from "constants/Constants";
import CheckboxShareModal from '../../ui/checkobox-share-modal/CheckboxShareModal'
import { CHOOSE_NEED_HEADER, CUSTOMIZATION_HEADER, FAMILY_PROFILE_HEADER, PREVIEW_SHARE_HEADER } from "constants/UserClicksConstant";
import PasaValidationModal from "../pasa-validation-modal/PasaValidationModal";
import fetchNavigationScreen from "utils/fetchNavigationScreen";
import getCookieValue from "utils/getCookieValue/getCookieValue";
import isReverseApiCall from "utils/isReverseApiCall";

class Breadcrumb extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNextButton: false,
      showPreviousButton: false,
      showErrorModal: false,
      showCheckboxShareModal: false,
      showPasaValidationModal: false,
      activePage: "choose-needs",
      routeList: [
        {
          path: "/choose-needs",
          key: "choose-needs",
          label: "Choose Needs",
          flag: false,
        },
        {
          path: "/family-details",
          key: "family-details",
          label: "Family Profile",
          flag: false,
        },
        {
          path: `/${localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)}`,
          key: localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION),
          label: "Customization",
          flag: false,
        },
        {
          path: "/preview-share",
          key: "preview-share",
          label: "Preview & Share",
          flag: false,
        },
        {
          path: "/quotation-preview",
          key: "quotation-preview",
          label: "Preview & Share",
          flag: false,
        },
        {
          path: "/share-quote",
          key: "share-quote",
          label: "Share Quote",
          flag: false,
        },
        {
          path: "/journey-complete",
          key: "journey-complete",
          label: "Journey Complete",
          flag: false,
        },
      ],
      routeListForBreakCrumb: ['choose-needs', 'family-details', 'preview-share', 'quotation-preview', 'share-quote', 'journey-complete'],

      chooseNeedFormController: {}
    };
    this.fetchList = this.fetchList.bind(this);
    this.onNextBtnClick = this.onNextBtnClick.bind(this);
    this.onPreviousClick = this.onPreviousClick.bind(this);
  }

  async componentDidMount() {
    let pageArray = this.state.routeListForBreakCrumb
    pageArray.splice(2, 0, localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION))
    this.setState({ routeListForBreakCrumb: pageArray })
    this.fetchList();
    let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID) ? getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID) : null
    let current_screen = this.props.match.params.selectedPage ? this.props.match.params.selectedPage : null
    await this.saveScreen(current_screen, null, journey_id)
  }

  async componentDidUpdate(prevProps) {
    if (this.props.match.params.selectedPage !== prevProps.match.params.selectedPage) {
      this.fetchList();
      let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID) ? getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID) : null
      let current_screen = this.props.match.params.selectedPage ? this.props.match.params.selectedPage : null
      let previous_screen = prevProps.match.params.selectedPage ? prevProps.match.params.selectedPage : null
      await this.saveScreen(current_screen, previous_screen, journey_id)
    }
  }

  fetchList() {
    const selectedPage = this.props.match.params.selectedPage;
    let pasaCampaignProduct = sessionStorage.getItem(StorageKeys.IS_PASA_PRODUCT) === "true" ? true : false
    this.state.routeList.map((item) => {
      item.flag = false;
    });
    if (selectedPage == undefined) {
      this.state.routeList[0].flag = true;
    } else {
      for (var i = 0; i < this.state.routeList.length; i++) {
        if (pasaCampaignProduct && (this.state.routeList[i].key == "choose-needs" || this.state.routeList[i].key == "family-details")) {
          this.state.routeList[i].flag = false;
        } else {
          this.state.routeList[i].flag = true;
        }
        if (this.state.routeList[i].key == selectedPage) {
          break;
        }
      }
      this.setState({
        activePage: selectedPage,
      });
    }

    if (selectedPage == "journey-complete") {
      this.setState({
        showNextButton: false,
      });
    } else {
      this.setState({
        showNextButton: true,
      });
    }

    if (selectedPage == "journey-complete" || selectedPage == "choose-needs") {
      this.setState({
        showPreviousButton: false,
      });
    } else {
      this.setState({
        showPreviousButton: true,
      });
    }
    this.setState({});
  }



  familyDetailsValidationForExpenseAndEmiAndLAPR(formController, isValid) {
    let ifValid = isValid
    const monthlyExpenseValueList = toJS(FamilyDetailsStore.familyDetailMonthlyExpenseValueList)
    const monthlyExpenseErrorList = toJS(FamilyDetailsStore.familyDetailsMonthlyExpenseErrorList)

    const emiValueList = toJS(FamilyDetailsStore.familyDetailsEmiValueList)
    const emiErrorList = toJS(FamilyDetailsStore.familyDetailsEmiErrorList)

    const savingValueList = toJS(FamilyDetailsStore.familyDetailsSavingValueList)
    const savingsErrorList = toJS(FamilyDetailsStore.familyDetailsSavingErrorList)

    if (monthlyExpenseErrorList.length !== 0) {
      monthlyExpenseErrorList.forEach((item) => {
        if (checkIsValueEmpty(monthlyExpenseValueList[item])) {
          formController.$("monthly_expense").$(item).invalidate("This field is mandatory")
          ifValid = false
        }
      })
    }
    if (emiErrorList.length !== 0) {
      emiErrorList.forEach((item) => {
        if (checkIsValueEmpty(emiValueList[item].option_range.value)) {
          ifValid = false
          formController.$("monthly_emi").$(item).$("option_range").invalidate("This field is mandatory");
        }
        if (checkIsValueEmpty(emiValueList[item].paid_years.value)) {
          ifValid = false
          formController.$("monthly_emi").$(item).$("paid_years").invalidate("This field is mandatory")
        }

        if (checkIsValueEmpty(emiValueList[item].total_years.value)) {
          ifValid = false
          formController.$("monthly_emi").$(item).$("total_years").invalidate("This field is mandatory")
        }
      })
    }
    if (savingsErrorList.length !== 0) {
      savingsErrorList.forEach((item) => {
        if (checkIsValueEmpty(savingValueList[item])) {
          ifValid = false
          formController.$("savings").$(item).invalidate("This field is mandatory")
        }
      })
    }

    let familyData = Object?.entries(formController?.$("members")?.get())
    let isLifeAssuredSelected = familyData?.some((item) => item[1]?.value?.life_assured)
    let isProposerSelected = familyData?.some((item) => item[1]?.value?.proposer)
    if (!isLifeAssuredSelected || !isProposerSelected) {
      // AuthStore.setErrorModal("LifeAssured & Proposer combination is Mandatory");
      ifValid = false
    }

    return ifValid
  }

  fetchDocumentList = async () => {
    const solutionIds = JSON.parse(localStorage.getItem("solutionList"));
    const idsAsString = solutionIds.toString();

    const response = await axios.get(
      APITypes.GET_DOCUMENT_LIST + `?ids=${idsAsString}`
    );
    return response;
  };



  async onNextBtnClick(directedPage) {
    let selectedPage = this.props.match.params.selectedPage;
    fetchNavigationScreen()
    let journeyId = "";
    if (getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)) {
      journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
    }

    if (directedPage) {
      selectedPage = directedPage
    }

    if (selectedPage === 'choose-needs') {
      localStorage.setItem('directedPageFromNavigation', 'family-details');
    }

    if (selectedPage == 'customization') {
      let productListData = toJS(OptimizationStore.product_list_data)
      let familyProductIdList = productListData.flatMap(item => item?.data?.map(product => product?.family_product_id) || [])
      OptimizationStore.familyProductIdList = familyProductIdList
      let pasaCampaignProduct = sessionStorage.getItem(StorageKeys.IS_PASA_PRODUCT) === "true" ? true : false
      if (pasaCampaignProduct) {
        let isTotalSumAssured = await OptimizationStore.calculateTotalSumAssuredOfAllProduct()
        if (!isTotalSumAssured) {
          this.setState({ showPasaValidationModal: true })
        } else {
          this.proceedCustomizationToSoluctionScreen()
        }
      } else {
        this.proceedCustomizationToSoluctionScreen()
      }
    } else if (selectedPage == 'preview-share') {
      const response = await this.fetchDocumentList();
      if (response.data?.length > 0) {
        this.setState({ showCheckboxShareModal: true })
      } else {
        this.proceedSoluctionToQmsScreen(
          getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
        );
      }
    } else {
      let { formController, callbackFunctions } = this.context;
      formController.validate({ showErrors: true }).then(({ isValid }) => {

        let ifValid
        if (selectedPage == 'family-details') {
          ifValid = this.familyDetailsValidationForExpenseAndEmiAndLAPR(formController, isValid)
        } else {
          ifValid = isValid
        }


        if (ifValid) {
          if (callbackFunctions.success !== undefined) {
            callbackFunctions.success(formController).then(() => {
              this.proceedToNextScreen()
            });
          }
        } else {
          let monthly_expense_types = formController.errors()?.monthly_expense ? formController.errors()?.monthly_expense : false;
          Object.keys(monthly_expense_types).map((ExpenseName, i) => {
            monthly_expense_types[ExpenseName] == null ? this.props.updateErrorClass("") : this.props.updateErrorClass("text-danger")
          })
          console.log("Form errors are ", formController.errors());
          if (callbackFunctions.error !== undefined) {
            callbackFunctions.error(formController);
          }
          // this.openErrorModal()
          this.setState({ showErrorModal: true })
        }
      });
    }
  }
  async saveDocumentData() {
    const solutionIds = JSON.parse(localStorage.getItem("solutionList"));
    let requestData = solutionIds.map((item) => {
      return {
        "solution_id": item,
        "document_list": []
      }
    })
    const saveDocumentData = await axios.post(
      APITypes.SAVE_DOCUMENT_LIST,
      requestData
    );

    if (saveDocumentData.status === "success") {
      AuthStore.setSharePdfData(saveDocumentData?.data?.pdf_data)
      AuthStore.setshowSharePdfModal(true)
    }
  }

  async proceedCustomizationToSoluctionScreen() {

    let listOfDisabledNeeds = toJS(OptimizationStore.listOfTotalNeeds)
    let recalculateBtn = false
    let productListData = toJS(OptimizationStore.product_list_data)

    productListData.forEach((item) => {
      item.data.forEach((value) => {
        if (value.BI.length > 0) {
          value.BI.map((tab) => {
            if (tab.fieldChanged && !recalculateBtn) recalculateBtn = true;
          });
        } else {
          if (value.fieldChanged && !recalculateBtn) recalculateBtn = true;
        }
      });
    })

    if (listOfDisabledNeeds.every(item => item === true)) {
      OptimizationStore.setShowSelectAtLeastOneNeed(true)
    } else if (recalculateBtn) {
      OptimizationStore.setRecalculateProductsSpecs(true)
    } else {
      const response = await OptimizationStoreOld.onGenerateSolutionData();
      if (response.status == 'success') {
        OptimizationStore.setShowSelectAtLeastOneNeed(false)
        await SolutionStore.fetchSolutionData()
        await SolutionStore.customerDetailsModalToggleFunction(true)
        await SolutionStore.isCloseModalOpen === false
        SolutionStore.fetchAgentEmail()
      }
    }

  }

  async proceedSoluctionToQmsScreen(journeyId) {
    let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
    let source_system = getCookieValue("source")
    if (isReverseApiCall()) {
      let dataResponse = axios.post(APITypes.REVERSE_LEAD_STATUS, { journeyId: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID) })
    }
    if (source_system === SAMS_JOURNEY || source_system === BANCA_JOURNEY) {
      let dataResponse = axios.post(APITypes.SMAS_LEAD_STATUS, { journeyId: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID) })
    }
    const pdfResponse = await QuotationPreviewUtils.sendSolutionList()
    if (pdfResponse.status === "success") {
      console.log("toJS(AuthStore.solutionData).solution_id ::: ", toJS(AuthStore.solutionData).solution_id)
      console.log("toJS(SolutionStore.seletedSolutionTabData).id ::: ", toJS(SolutionStore.seletedSolutionTabData).proposer_id)
      this.props.history.push(`/qms/qms-details`,
        {
          agent_details: {
            pragati_home_url: localStorage.getItem(StorageKeys.PRAGATI_HOME_URL),
            pragati_post_call_end_point_url: localStorage.getItem(StorageKeys.PRAGATI_POST_CALL_END_POINT_URL),
            authToken: sessionStorage.getItem(StorageKeys.AUTH_TOKEN),
            agent_id: localStorage.getItem(StorageKeys.AGENT_ID),
            agent_code: localStorage.getItem(StorageKeys.AGENT_CODE),
            agent_name: localStorage.getItem(StorageKeys.AGENT_NAME),
            login_code: localStorage.getItem(StorageKeys.LOGIN_CODE),
            vendor: localStorage.getItem(StorageKeys.VENDOR),
            source_from: localStorage.getItem(StorageKeys.SOURCE_FROM),
            login_agent_code: localStorage.getItem(StorageKeys.LOGIN_AGENT_CODE),
            first_time_optimization_page_load_param: localStorage.getItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM),
          },
          journeyId: journeyId,
          solutionId: toJS(AuthStore.solutionData).solution_id,
          proposerId: toJS(QuotationPreviewStore.selectedTabData).proposer_id
        });
    }
    localStorage.setItem("showCoverageMsg", false)

  }





  proceedToNextScreen() {
    const selectedPage = this.props.match.params.selectedPage
    const journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)

    switch (selectedPage) {

      case 'choose-needs':
        let { formController } = this.context;
        this.setState({ chooseNeedFormController: formController })
        ChooseNeedsStore.setChooseNeedFormControllerFromStore(formController)
        this.props.history.push(`/family-details`);
        break;
      case 'family-details':
        localStorage.setItem('directedPageFromNavigation', localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION));
        setTimeout(async () => {
          const getAllDataResponse = await AuthStore.fetchJourneyData()
          this.updateCalculatorValue(getAllDataResponse, journeyId, this.state.chooseNeedFormController)
        }, 0);

        let optimizationScreenLoad = localStorage.getItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM)
        if (optimizationScreenLoad === null || optimizationScreenLoad === "null") {
          localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, true)
        } else {
          localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, false)
        }
        this.props.history.push(`/${localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)}`);
        break;
      case 'customization':
      case 'customization-old':
        // TODO :: Need to implement the route
        localStorage.setItem('directedPageFromNavigation', 'preview-share')
        // this.props.history.push(`/solution/${journeyId}`);
        break;

      case 'preview-share':
        // TODO :: Need to implement the route
        localStorage.setItem('directedPageFromNavigation', 'quotation-preview')
        break;
      case 'quotation-preview':
        AuthStore.setCurrentPage('journey-complete')
        localStorage.setItem('directedPageFromNavigation', 'journey-complete')
        this.props.history.push(`/journey-complete/`);
        break;
      case 'share-quote':
        // TODO :: Need to implement the route
        break;
      case 'journey-complete':
        // TODO :: Need to implement the route
        break
      default:
        break;
    }
  }


  updateCalculatorValue = async (getAllDataResponse, journeyId, IsChooseNeedFormController) => {

    let { formController } = this.context;

    if (IsChooseNeedFormController) {
      formController = IsChooseNeedFormController
    }

    let { expense_list, user_emi, family_details_list } = getAllDataResponse.data

    const emiLabelList = ['Home Loan EMI', 'Car Loan EMI', 'Other Loan EMI', 'Personal Loan EMI']

    // ! remove emi expense from the expense list
    expense_list = expense_list.filter(item => !emiLabelList.includes(item.expense_label))

    // ! create expense array 
    expense_list = expense_list.map((item) => {
      const { expense_range_id, expense_range_key, expense_range_value } = item
      return { action: "save", id: expense_range_id, expense_range_id, expense_range_key, expense_range_value, user_journey: journeyId }
    })

    // ! create emi array
    let emi_list = user_emi.map((item) => {
      const { expense_range, expense_range_key, expense_range_value, paid_loan_tenure: paid_years, total_loan_tenure: total_years } = item
      return {
        action: "save",
        id: expense_range,
        expense_range_id: expense_range,
        expense_range_key,
        expense_range_value,
        user_journey: journeyId,
        paid_years,
        total_years
      }
    })

    let selfDetails = family_details_list.find(item => item.family_member_type === "SELF" || item.family_member_type === "EMPLOYEE" || item.family_member_type === "FAMILY_MEMBER")

    let { id, dob, current_life_cover, monthly_income, user_journey } = selfDetails

    let protectionCalculatorReqObj = toJS(ChooseNeedsStore.protectionCalculatorReqObj)

    if (ChooseNeedsStore.isProtectionCalculatorUsed) {
      let formattedDob = dob
      let validate = moment(dob, 'DD-MM-YYYY', true).isValid()
      if (validate) {
        formattedDob = moment(dob, 'DD-MM-YYYY').format('YYYY-MM-DD')
      } else {
        formattedDob = moment(dob).format('YYYY-MM-DD')
      }
      let dataToBeSubmitted = {
        ...protectionCalculatorReqObj,
        dob: formattedDob,
        current_life_cover,
        emi_list,
        expense_list,
        monthly_income,
        journey_id: user_journey,
        family_member_id: id,
      }

      var response = await axios.post(APITypes.PROTECTION_CALCULATOR, dataToBeSubmitted);

      if (response.status == 'error') {
        return
      } else {
        await AuthStore.fetchJourneyData()
        const chooseNeedController = formController

        chooseNeedUtils.updateTargetAmountValue(chooseNeedController, "protection_for_my_family", response.data.lumpsum)
        chooseNeedController.$("protection_for_my_family.is_value_updated").set("value", true)
      }
    }

    if (ChooseNeedsStore.isRetirementCalculatorUsed) {
      let formattedDob = dob
      let validate = moment(dob, 'DD-MM-YYYY', true).isValid()
      if (validate) {
        formattedDob = moment(dob, 'DD-MM-YYYY').format('YYYY-MM-DD')
      } else {
        formattedDob = moment(dob).format('YYYY-MM-DD')
      }
      let dataToBeSubmitted = {
        ...protectionCalculatorReqObj,
        dob: formattedDob,
        current_life_cover,
        expense_list,
        monthly_income: "0",
        journey_id: user_journey,
        family_member_id: id,
      }

      let response = await axios.post(APITypes.RETIREMENT_CALCULATOR, dataToBeSubmitted)
      if (response.data.status == 'error') {
        return
      } else {
        await AuthStore.fetchJourneyData()
        const chooseNeedController = formController

        chooseNeedUtils.updateTargetAmountValue(chooseNeedController, "save_for_retirement", response.data.annual_income)
        chooseNeedController.$("save_for_retirement.is_value_updated").set("value", true)
      }
    }
  }


  async saveScreen(currentSreen, prevousScreen, journeyId) {
    await axios.post(APITypes.SAVE_CURRENT_SCREEN, {
      "journey_id": journeyId,
      "current_screen": currentSreen,
      "previous_screen": prevousScreen
    })
  }


  async onPreviousClick(directedPage) {

    const isDirectedFromQMS = localStorage.getItem("directedFromQMS")

    let selectedPage = this.props.match.params.selectedPage;
    let pasaCampaignProduct = sessionStorage.getItem(StorageKeys.IS_PASA_PRODUCT) === "true" ? true : false

    if (pasaCampaignProduct && selectedPage === "customization") {
      return
    }


    if (directedPage) {

      if (directedPage === 'choose-needs') {
        selectedPage = 'family-details'
      } else if (directedPage === 'family-details') {
        selectedPage = localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)
      } else if (directedPage === 'customization' || 'customization-old') {
        selectedPage = "preview-share"
      } else if (directedPage === 'preview-share') {
        selectedPage = "quotation-preview"
      }
    }

    switch (selectedPage) {
      case 'family-details':
        localStorage.setItem('directedPageFromNavigation', 'choose-needs');
        break;

      case 'customization':
      case 'customization-old':
        localStorage.setItem('directedPageFromNavigation', 'family-details');
        break;

      case 'preview-share':
        localStorage.setItem('directedPageFromNavigation', localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION));
        break;

      case 'quotation-preview':

        localStorage.setItem('directedPageFromNavigation', 'preview-share');
        break;

      default:
        break;
    }


    let journeyId = "";
    if (getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)) {
      journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
    }

    if (directedPage) {
      // await this.saveScreen(directedPage,journeyId)
    } else {

      let directedPageName = ''

      switch (selectedPage) {

        case "choose-needs":
          directedPageName = "choose-needs"
          break;

        case "family-details":
          directedPageName = "choose-needs"
          break;

        case "customization":
        case "customization-old":
          directedPageName = "family-details"
          break;

        case "preview-share":
          directedPageName = localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)
          break;

        case "quotation-preview":
          directedPageName = "preview-share"
          break;

        default:
          break;
      }
      // await this.saveScreen(directedPageName,journeyId)
    }

    await AuthStore.fetchJourneyData()
    switch (selectedPage) {

      case "choose-needs":
        setTimeout(async () => {
          const getAllDataResponse = await AuthStore.fetchJourneyData()
          this.props.history.push(`/choose-needs`);
          this.updateCalculatorValue(getAllDataResponse, journeyId)
        }, 0);
        break

      case "family-details":
        let { formController, callbackFunctions } = this.context;

        formController.validate({ showErrors: true }).then(({ isValid }) => {

          if (isValid) {
            if (callbackFunctions.success !== undefined) {
              callbackFunctions.success(formController).then(() => {
                setTimeout(async () => {
                  const getAllDataResponse = await AuthStore.fetchJourneyData()
                  this.props.history.push(`/choose-needs/`);
                  this.updateCalculatorValue(getAllDataResponse, journeyId)
                }, 0);
              })
            }
          } else {
            console.log("Form errors are ", formController.errors());
            if (callbackFunctions.error !== undefined) {
              callbackFunctions.error(formController);
            }
          }
        });
        // this.props.history.push(`/choose-needs/${journeyId}`);
        break;
      case "customization":
      case "customization-old":
        this.props.history.push(`/family-details/`);
        break;
      case "preview-share":
        localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, false)

        if (JSON.parse(isDirectedFromQMS) === true) {
          this.props.history.push(`/${localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)}`);
          localStorage.setItem('directedFromQMS', false)
        } else {
          this.props.history.goBack(`/${localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)}`);
          localStorage.setItem('directedFromQMS', false)
        }
        // this.props.history.goBack(`/customization/${journeyId}`);
        // this.props.history.push(`/customization/${journeyId}`);

        break;
      case "share-quote":
        // this.props.history.push(`/solution/${journeyId}`);
        break;
      case "quotation-preview":
        localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, false)

        if (JSON.parse(isDirectedFromQMS) === true) {
          this.props.history.push(`/preview-share/`);
          localStorage.setItem('directedFromQMS', false)
        } else {
          this.props.history.goBack(`/preview-share/`);
          localStorage.setItem('directedFromQMS', false)
        }

        // this.props.history.push(`/solution/${journeyId}`);
        // this.props.history.goBack(`/solution/${journeyId}`);

        break;
      default:
        break;
    }
  }



  BreadcrumbFunction = (e) => {
    const selectedPage = this.props.match.params.selectedPage

    const isDirectedFromQMS = localStorage.getItem("directedFromQMS")

    const currentPage = selectedPage
    const directedPage = e.currentTarget.name.slice(1)
    //! for save user clicks
    switch (directedPage) {
      case "choose-needs":
        AuthStore.saveUserClicks(CHOOSE_NEED_HEADER)
        break;
      case "family-details":
        AuthStore.saveUserClicks(FAMILY_PROFILE_HEADER)
        break;
      case "customization":
        AuthStore.saveUserClicks(CUSTOMIZATION_HEADER)
        break;
      case "preview-share":
        AuthStore.saveUserClicks(PREVIEW_SHARE_HEADER)
        break;

      default:
        break;
    }
    if (currentPage === 'preview-share' && directedPage === localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)) {
      // this.saveScreen(directedPage,this.props.match.params.journeyId)

      if (JSON.parse(isDirectedFromQMS) === true) {
        this.props.history.push(`/${localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)}`);
        // localStorage.setItem('directedFromQMS', false)
      } else {
        this.props.history.goBack(`/${localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)}`);
        localStorage.setItem('directedFromQMS', false)
      }

      // this.props.history.goBack(`/customization/${this.props.match.params.journeyId}`);
      // this.props.history.push(`/customization/${this.props.match.params.journeyId}`);
    } else if (currentPage === 'quotation-preview' && directedPage === localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION)) {
      // this.saveScreen(directedPage,this.props.match.params.journeyId)
      this.props.history.go(-2);
    } else {
      if (this.state.routeListForBreakCrumb.indexOf(currentPage) > this.state.routeListForBreakCrumb.indexOf(directedPage)) {
        this.onPreviousClick(directedPage)
      } else if (this.state.routeListForBreakCrumb.indexOf(currentPage) < this.state.routeListForBreakCrumb.indexOf(directedPage)) {
        this.onNextBtnClick(directedPage)
      }
    }
  };


  openErrorModal = () => {
    const { innerWidth: width } = window;
    if (width < 1200) this.setState({ showErrorModal: true })
    else this.setState({ showErrorModal: false })
  }

  closeErrorModal = () => {
    this.setState({ showErrorModal: false })
  }

  yesCoverageModal = () => {
    let coverage = localStorage.getItem('coverage')
    if (coverage === "true") {
      this.setState({ showCoverageMsg: true })
      localStorage.setItem("showCoverageMsg", true)
      setTimeout(() => {
        this.setState({ showCoverageMsg: false })
        this.proceedSoluctionToQmsScreen(journeyId)
      }, 1000);
    } else {
      this.proceedSoluctionToQmsScreen(journeyId)
    }
  }

  noCoverageModal = () => {
    this.setState({ showCoverageMsg: false })
  }


  yesShowCheckboxShareModal = async (data) => {
    const journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
    const saveDocumentData = await axios.post(
      APITypes.SAVE_DOCUMENT_LIST,
      data
    );
    if (saveDocumentData.status == "success") {
      let coverage = localStorage.getItem('coverage')
      if (coverage === "true") {
        this.setState({ showCheckboxShareModal: true })
        localStorage.setItem("showCoverageMsg", true)
        setTimeout(() => {
          this.setState({ showCheckboxShareModal: false })
          this.proceedSoluctionToQmsScreen(journeyId)
        }, 1000);
      } else {
        this.proceedSoluctionToQmsScreen(journeyId)
      }
    }
  }

  noShowCheckboxShareModal = () => {
    this.setState({ showCheckboxShareModal: false })
  }

  processToNonPasa = async () => {
    let journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
    const response = await axios.get(
      `${APITypes.UPDATE_PASA_OR_NON_PASA_JOURNEY}?journeyId=${journeyId}&is_pasa_product=${false}`
    )
    if (!response.is_pasa_allow) {
      sessionStorage.setItem(StorageKeys.IS_PASA_PRODUCT, false)
      this.proceedCustomizationToSoluctionScreen()
      this.setState({ showPasaValidationModal: false })
    }
  }




  render() {
    let isExist = this.props.match.params.selectedPage == localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION) ? OptimizationStore.checkValidationExist : false;
    let sourceFrom = toJS(AuthStore.sourceFrom)

    return (
      <div className='breadcrumb pb-0 pt-0 px-1 w-100'>
        <Container className="breadcrumb-container">
          <div className='d-flex align-items-center justify-content-around'>
            <div className=''>
              <ul className='nav nav-tabs border-white border-bottom-0' id='productTab' role='tablist'>
                {this.state.routeList
                  .filter((value, index) => index <= 3)
                  .map((item, index) => {

                    return (
                      <li key={item.key} className={`nav-item d-flex align-items-center cursor-pointer ${!item.flag ? "disable-li" : ""} `}>
                        <a
                          className={`nav-link font-size-12 font-weight-light ${item.flag ? "text-dark" : "text-gray"} active ${!item.flag ? "disable-li" : ""} ${this.state.activePage == item.key ? "tab-border-bottom-secondary" : ""
                            }`}
                          //style={{ color: item.flag ? "#333333" : }}
                          onClick={this.BreadcrumbFunction}
                          id='explore-tab'
                          data-toggle='tab'
                          name={item.path}
                          // href={`${item.path}/${getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)}`}
                          role='tab'
                          aria-controls='explore'
                          aria-selected='true'
                        >
                          <span className={`breadcrumb-number ${this.state.activePage == item.key ? "boder-secondary" : "border-gray"}`}>{index + 1}</span>
                          <span className='d-none d-lg-inline ml-2'>{item.label}</span>
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>
            <div className='nextbtn '>
              <div className='btn-white-container d-flex justify-content-md-end py-2 p-md-0'>
                {sourceFrom === "Distribution_App" && <PreNeedSelectionModal {...this.props} />}
                {this.state.showPreviousButton && (
                  <UiButton
                    className='mr-1 mr-md-3 font-weight-light font-size-14 font-size-md-12 px-1 w-100 next-button'
                    variant='outline-secondary'
                    buttonText={this.state.activePage == "preview-share" ? "Back" : this.state.activePage == "quotation-preview" ? "Cancel" : "Previous"}
                    onClick={() => this.onPreviousClick()}
                  />
                )}

                {this.state.showNextButton && (
                  <NextButton
                    disabled={ChooseNeedsStore.isSelectedNeed || isExist}
                    buttonText={
                      this.state.activePage == "preview-share" ? (
                        <ShareButtonTitleComponent />
                      ) : this.state.activePage == localStorage.getItem(StorageKeys.SHOW_NEW_OPTIMIZATION) ? (
                        "Submit"
                      ) : this.state.activePage == "preview-share" ? (
                        "Preview"
                      ) : (
                        "Next"
                      )
                    }
                    onClick={() => this.onNextBtnClick()}
                  />
                )}
              </div>
            </div>
          </div>
        </Container>

        <Modal
          size='md'
          aria-labelledby='contained-modal-title-vcenter'
          centered
          backdrop='static'
          className='save-session-modal'
          show={this.state.showErrorModal}
          keyboard={false}
        >
          <Modal.Body className='text-center text-primary-title-label-color px-4 pt-4 pb-0'>
            <React.Fragment>
              <h3 className='font-weight-medium font-size-22 font-size-md-32 mb-3'>ERROR</h3>
              <p className='font-weight-normal font-size-20 font-size-md-24 mb-0'>Please fill the Required Details </p>
            </React.Fragment>
          </Modal.Body>
          <Modal.Footer className='d-block p-4 border-0'>
            <Row className='modal-footer-row'>

              <React.Fragment>
                <Col xs='12'>
                  <UiButton onClick={this.closeErrorModal} className='font-size-medium font-size-16 px-2 w-100 mb-2 mb-md-0' variant='secondary' buttonText='Close' />
                </Col>
                {/* <Col xs='12' >
                      <UiButton onClick={this.closeErrorModal} className='font-size-medium font-size-16 px-2 w-100' variant='outline-secondary' buttonText='Close' />
                    </Col> */}
              </React.Fragment>

            </Row>
          </Modal.Footer>
        </Modal>
        {
          this?.state?.showCheckboxShareModal === true &&
          <CheckboxShareModal
            show={this?.state?.showCheckboxShareModal}
            yesShowCheckboxShareModal={this.yesShowCheckboxShareModal}
            noShowCheckboxShareModal={this.noShowCheckboxShareModal}
            proceedSoluctionToQmsScreen={this.proceedSoluctionToQmsScreen}
          />
        }
        {this.state.showPasaValidationModal &&
          <PasaValidationModal
            show={this.state.showPasaValidationModal}
            processToNonPasa={this.processToNonPasa}
            cancelModal={() => { this.setState({ showPasaValidationModal: false }) }}
          />
        }
      </div>


    );
  }
}

Breadcrumb.contextType = FormContext;

const ShareButtonTitleComponent = () => {
  return (
    <div className='d-flex flex-row align-items-center justify-content-center w-100'>
      <span>Share</span>
      <Image className='ml-2' src={ShareIconImg} alt='share-icon' />
    </div>
  );
};





export default observer(Breadcrumb);
